const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const isTransient = (err) => !err?.response || err.response.status >= 500;

// Retries auth POSTs on network errors / 5xx (e.g. a short restart during deploy).
export async function postWithRetry(client, url, body, delays = [1500, 3000]) {
    for (let i = 0; ; i += 1) {
        try {
            return await client.post(url, body);
        } catch (err) {
            if (!isTransient(err) || i >= delays.length) throw err;
            await sleep(delays[i]);
        }
    }
}

export function authErrorMessage(err, fallback) {
    if (isTransient(err)) {
        return 'Sunucu şu an geçici olarak yanıt vermiyor (güncelleme/bakım olabilir). Birkaç saniye sonra tekrar dene.';
    }
    const d = err?.response?.data?.detail;
    if (typeof d === 'string') return d;
    if (Array.isArray(d) && d[0]?.msg) return 'Bilgileri kontrol et: email ve şifre geçerli olmalı.';
    return fallback;
}
